<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper flexbox-align-items">
                <div v-if="modalType !== 'handler'" :class="returnClass()" class="modal-container">
                    <button type="button" @click="closeModal" class="close-button">
                        <span aria-hidden="true" tabindex="-1">×</span>
                    </button>
                    <div class="modal-body">
                        <slot name="body">
                            <component :is="selectedView" @close="closeModal" :data="data"></component>
                        </slot>
                    </div>
                </div>
                <div v-else class="modal-container">
                    <div class="spinner-container spinner-container-modal">
                        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                    <h4 class="text-center">{{data}}</h4>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import administrationModalNewpassword from './../../pages/administration/administration-modal-newpassword.vue'
import administrationModalUserDrive from './../../pages/administration/drive/administration-modal-user-drive.vue'
import administrationModalSelectlistitemDrive from './../../pages/administration/drive/administration-modal-selectlistitem-drive.vue'
import administrationModalCompany from './../../pages/administration/administration-modal-company.vue'
import loginModalForgotPassword from './../../pages/login/login-modal-forgotpassword.vue'
import loginModalNewPassword from './../../pages/login/login-modal-newpassword.vue'
import loginModalOrganization from './../../pages/login/login-modal-organization.vue'

export default {
    name: 'modal',
    data () {
        return {
            selectedView: null,
            modalType: this.type,
            modalData: this.data,
            bigModal: false,
            smallModal: false
        }
    },
    props: [
        'type',
        'data'
    ],
    components: {
        'administration-modal-newpassword': administrationModalNewpassword,
        'administration-modal-user-drive': administrationModalUserDrive,
        'administration-modal-selectlistitem-drive': administrationModalSelectlistitemDrive,
        'administration-modal-company': administrationModalCompany,
        'login-modal-forgotpassword': loginModalForgotPassword,
        'login-modal-newpassword': loginModalNewPassword,
        'login-modal-organization': loginModalOrganization
    },
    computed: {
        ...mapGetters({
            application: 'getApplication'
        })
    },
    methods: {
        ...mapActions({
            setClearUserExist: 'setClearUserExist',
            setClearCompanyExist: 'setClearCompanyExist',
            setNonSelectedMultipleSupplyType: 'setNonSelectedMultipleSupplyType'
        }),
        closeModal () {
            if (this.application && (this.modalType === 'administration-modal-user-' + this.application.value)) {
                this.setNonSelectedMultipleSupplyType()
                this.setClearUserExist()
            }
            if (this.modalType === 'administration-modal-company') {
                this.setClearCompanyExist()
            }
            this.$emit('close')
        },
        returnClass () {
            if (this.smallModal) {
                return 'small-modal-container'
            }
            if (this.bigModal) {
                return 'big-modal-container'
            }
        }
    },
    created () {
        this.selectedView = this.modalType
        if (this.modalType === 'administration-modal-user-drive') {
            this.bigModal = true
        }
        if (this.modalType === 'login-modal-forgotpassword' || 'login-modal-organization') {
            this.smallModal = true
        }
        if (this.modalType === 'administration-modal-selectlistitem-drive') {
            this.bigModal = true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/modal/modal.vue